import { Component, ElementRef, Inject, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
    selector: 'projected-balance',
    templateUrl: './projected-balance.component.html',
    styleUrls: ['./projected-balance.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ProjectedBalanceComponent extends DialogPanelComponentContent implements OnInit {
    public financePosition: any;
    public projectedFinance: number;
    public projectedFinancePerDay: { date: string, value: number, color: string }[];
    public projetedFinanceColor = '#000';
    public debitValue: number;

    constructor(
        public dialogReference: MatDialogRef<ProjectedBalanceComponent>,
        element: ElementRef,
        private router: Router,
        private renderer: Renderer2,
        private store: Store<AppState>,
        @Inject(MAT_DIALOG_DATA) public data,
    ) {
        super(element, true);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.debitValue = this.data.debitValue;
        this.financePosition = this.data.userFinancePosition;
        this.projectedFinance = this.financePosition.projectedD1 + this.financePosition.projectedD2 + this.financePosition.projectedD3 + this.financePosition.projectedDM3;
        this.projectedFinancePerDay = [
            {
                date: this.financePosition.dateD1,
                value: this.financePosition.projectedD1,
                color: this.getProjectedColor(this.financePosition.projectedD1)
            },
            {
                date: this.financePosition.dateD2,
                value: this.financePosition.projectedD2,
                color: this.getProjectedColor(this.financePosition.projectedD2)
            }
        ]
    }

    public closeMenu() {
        super.close(this.dialogReference, null);
        this.renderer.removeClass(document.body, 'overflow--hidden');
    }

    public getProjectedColor(value) {
        if (value > 0) {
            return '#006D51';
        } else if (value < 0) {
            return '#A3141E';
        }
    }

    public capitalizeDate(value) {
        const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
        return capitalizedValue;
    }

    public redirectDeposit() {
        this.closeMenu();
        this.router.navigate(['/transferencia'], { queryParams: {category: 'activeAccount'}});

        this.sendTracking("Element Clicked", {
            'Product Area Origin': this.data.productAreaOrigin,
            'Time Responsável': "Roebling",
            'Element': 'Botão transferir recursos',
            'Step': 'Lançamentos futuros',
            'Scenario': 'Saldo insuficiente',
            'Group': 'Informações da conta',    
        })
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }
}
